import React from "react";
import MainLayout from "../../layouts/MainLayout";
import LeadFormEmbeddedPage from "../../modules/LeadForm/LeadFormEmbeddedPage";
import { getGetQuotePageHeader } from "../../util/seoUtil";
import SyncNextStyleHead from "../../components/seo/SyncNextStyleHead";

function GetQuotePage() {
  return (
    <MainLayout>
      <SyncNextStyleHead>{getGetQuotePageHeader()}</SyncNextStyleHead>
      <LeadFormEmbeddedPage overRideForm="delhi-ncr" />
    </MainLayout>
  );
}

export default GetQuotePage;
